class Console {
    public static warn(...args) {
        console.warn(...args);
    }
}

export { Console };
